export default "__VITE_ASSET__30acfba1__"